import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { report, reportCategory } from 'src/app/dashboards/models';
import { ReportsDialogSaveAsEditComponent, DialogSaveAsEditTypes, DialogSaveAsEditData } from 'src/app/reports/reports-details/nested-components/reports-dialog-save-as-edit/reports-dialog-save-as-edit.component';
import { I18NextPipe } from 'angular-i18next';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import { DialogDeleteComponent } from 'src/app/common/dialogs/dialog-delete/dialog-delete.component';

@Component({
    selector: 'app-reports-list-page',
    templateUrl: './reports-list-page.component.html',
    styleUrls: ['./reports-list-page.component.scss'],
    standalone: false
})
export class ReportsListPageComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {

  }
}
